import BaseParameterAction from './BaseParameterAction.js';

class MoveAutomationBreakPointAction extends BaseParameterAction {
    execute({automation, points, stepDiff, valueDiff}) {
        automation.movePoints(points, stepDiff, valueDiff);
    }
}

export default MoveAutomationBreakPointAction;
